import React from 'react'
import i18next from 'i18next'
export const i18nextOpts = {
  lng: ((typeof avant !== 'undefined' && avant.locale) || `en-US`),
  fallbackLng: 'en-US',
  resources:{
    [`en-US`]:{
      translation:{
        ...require('../../translations.yml')[`en-US`]
      }
    },
    [`en-GB`]:{
      translation:{
        ...require('../../translations.yml')[`en-GB`]
      }
    },
    [`eloan`]:{
      translation:{
        ...require('../../translations.yml')[`eloan`]
      }
    },
    [`hsbc`]:{
      translation:{
        ...require('../../translations.yml')[`hsbc`]
      }
    },
    [`pnc`]:{
      translation:{
        ...require('../../translations.yml')[`pnc`]
      }
    },
    [`regions`]:{
      translation:{
        ...require('../../translations.yml')[`regions`]
      }
    },
    [`td`]:{
      translation:{
        ...require('../../translations.yml')[`td`]
      }
    },
  },
  interpolation:{
    nestingPrefix: '%{',
    nestingSuffix: '}',
    prefix: '%{',
    suffix: '}'
  }
}

export class AvantI18nProvider extends React.Component{
  constructor(props, context){
    super(props, context)
    i18next.init(i18nextOpts, (err, t) => this.state = { t })
  }

  getChildContext(){
    return{
      t: this.state.t
    }
  }
  render(){
    return React.Children.only(this.props.children)
  }
}

AvantI18nProvider.childContextTypes = {
  t: React.PropTypes.func.isRequired
}
